import TipoSelo from "./tipo-selo";
import Serventia from "./serventia";
import AtoMovimento from "./ato-movimento";
import PedidoSelo from "./pedido-selo";
import ValorSeloAto from "./valor-selo-ato";

export default class Selo {

  constructor(item) {
    if (item.selo) {
      this.idSelo = item.selo.idSelo;
      this.numero = item.selo.numero;
      this.chave = item.selo.chave;
      this.estado = item.selo.estado;
      if (item.selo.tipoSelo) {
        this.tipoSelo = new TipoSelo(item.selo.tipoSelo);
      }
    } else {
      this.numero = item.numeroSelo;
      let p = item.pedidoSeloDto;
      this.tipoSelo = new TipoSelo(null, p.idTipoSelo, p.descricaoTipoSelo, p.cor, p.codAbnote);
    }
    this.seloManual = item.seloManual;

    if (item.pedidoSeloDto)
      this.pedidoSelo = new PedidoSelo(item.pedidoSeloDto);

    if (item.atoMovimento)
      this.atoMovimento = new AtoMovimento(item.atoMovimento);

    this.estadoSelo = item.estadoSelo;

    if (item.valorSeloAto)
      this.valorSeloAto = new ValorSeloAto(item.valorSeloAto);

    if (item.serventia)
      this.serventia = new Serventia(item.serventia);
  }

  get imagem() {
    return Selo.getImagePath(this.tipoSelo.id);
  }

  isDigital() {
    try {
      return this.tipoSelo.id >= 9;
    } catch (error) {
      return false;
    }
  }

  static getImagePath(tiposelo_ou_id) {
    let path;
    switch (true) {
      case tiposelo_ou_id === 1:
      case tiposelo_ou_id === 'AUTENTICAÇÂO':
        path = '/static/selos/1-Aut.jpg';
        break;

      case tiposelo_ou_id === 2:
      case tiposelo_ou_id === 'RECONHECIMENTO DE FIRMA':
        path = '/static/selos/2-Rec.jpg';
        break;

      case tiposelo_ou_id === 3:
      case tiposelo_ou_id === 'CERTIDÃO':
        path = '/static/selos/3-Cert.jpg';
        break;

      case tiposelo_ou_id === 4:
      case tiposelo_ou_id === 'NOTARIAL E REGISTRAL':
        path = '/static/selos/4-Not.jpg';
        break;

      case tiposelo_ou_id === 5:
      case tiposelo_ou_id === 'ISENTO - VERMELHO':
        path = '/static/selos/5-Isento.jpg';
        break;

      case tiposelo_ou_id === 6:
      case tiposelo_ou_id === 'FISCALIZAÇÃO (01 ATO)':
        path = '/static/selos/6-1Ato.jpg';
        break;

      case tiposelo_ou_id === 7:
      case tiposelo_ou_id === 'FISCALIZAÇÃO (02 ATOS)':
        path = '/static/selos/7-2Atos.jpg';
        break;

      case tiposelo_ou_id === 8:
      case tiposelo_ou_id === 'FISCALIZAÇÃO (ISENTO)':
        path = '/static/selos/8-Isento.jpg';
        break;

      /*Digital*/
      case tiposelo_ou_id === 10:
      case tiposelo_ou_id === 'SELO DIGITAL ISENTO':
        path = '/static/selos/SeloDigitalIsento01.jpg';
        break;

      case tiposelo_ou_id >= 9:
      case tiposelo_ou_id === 'SELO DIGITAL':
        path = '/static/selos/SeloDigitalSemNum.jpg';
        break;
    }
    return path;
  }
}



// WEBPACK FOOTER //
// ./src/domain/selo/selo.js